<template>
    <form>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label class="label" v-text="$t('name_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <input
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has('newOffice.name') }"
                            v-model="newOffice.name"
                            name="newOffice.name"
                            type="name">
                        <span v-show="errors.has('newOffice.name')" class="icon is-rightis-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-8">
                <div class="field">
                    <label class="label" v-text="$t('street_name_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <input
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has('newOffice.streetName') }"
                            v-model="newOffice.streetName"
                            name="newOffice.streetName"
                            type="streetName">
                        <span v-show="errors.has('newOffice.streetName')" class="icon is-rightis-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                </div>
            </div>
            <div class="column is-4">
                <div class="field">
                    <label class="label" v-text="$t('street_number_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <input
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has('newOffice.streetNumber') }"
                            v-model="newOffice.streetNumber"
                            name="newOffice.streetNumber"
                            type="streetNumber">
                        <span v-show="errors.has('newOffice.streetNumber')" class="icon is-rightis-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-4">
                <div class="field">
                    <label class="label" v-text="$t('zip_code_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <input
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has('newOffice.zipCode') }"
                            v-model="newOffice.zipCode"
                            name="newOffice.zipCode"
                            type="zipCode">
                        <span v-show="errors.has('newOffice.zipCode')" class="icon is-rightis-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                </div>
            </div>
            <div class="column is-8">
                <div class="field">
                    <label class="label" v-text="$t('locality_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <input
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has('newOffice.locality') }"
                            v-model="newOffice.locality"
                            name="newOffice.locality"
                            type="locality">
                        <span v-show="errors.has('newOffice.locality')" class="icon is-rightis-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label class="label" v-text="$t('country_label')"></label>
                    <p class="control">
                        <div :class="{'select is-fullwidth': true, 'is-danger': errors.has('newOffice.countryId') }">
                            <select
                                class="is-block"
                                v-model="newOffice.countryId"
                                name="newOffice.countryId"
                                v-validate="'required'"
                                :disabled="Object.keys(countries).length == 1">
                                <option v-bind:value="null">{{ $t('select_country_label') }}</option>
                                <option v-for="(country, id) in countries" v-text="$t(`Countries_${countr.code}`)" v-bind:value="id"></option>
                            </select>
                        </div>
                    </p>
                    <p v-show="errors.has('newOffice.countryId')" class="help is-danger">{{ $t('select_country_label') }}</p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label class="label" v-text="$t('phone_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <input
                            v-validate="{
                                required: true,
                                regex: getPhoneRegex()
                            }"
                            :class="{'input': true, 'is-danger': errors.has(`newOffice.phone`) }"
                            v-model="newOffice.phone"
                            :name="`newOffice.phone`"
                            :placeholder="getCurrentCountryPhonePrefix() + '...'"
                            type="phone">
                        <span v-show="errors.has('newOffice.phone')" class="icon is-rightis-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                    <span v-show="errors.has('newOffice.phone')" class="help is-danger">{{ $t('phone_error', { prefix: getCurrentCountryPhonePrefix() }) }}</span>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label class="checkbox">
                        <input
                            type="checkbox"
                            v-model="newOffice.isEmergencyEmailAlertEnabled">
                            <span v-html="$t('emergency_alert_label')"></span>
                    </label>
                </div>
            </div>
        </div>
        <button @click.prevent="createOffice" class="button is-info mt-3">
            <b-icon icon="plus-circle"></b-icon>
            <span>{{ $t('create_button_label') }}</span>
        </button>
    </form>
</template>

<script>
import axios from 'axios'
import helpers from '@/mixins/helpers'
import firebase from 'firebase/app'
import { store } from '@/store'

import doctorOfficeRepository from '@/data/DoctorOfficeRepository'

const GEOCODE_BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json'

export default {
    name: 'profile-new-office',

    mixins: [helpers],

    data () {
        return {
            newOffice: {}
        }
    },

    created () {
        if (! this.defaultCountryId) {
            var country = _.find(this.countries, {code: 'be'})

            if (country) {
                store.dispatch('setDefaultCountryId', country.id)
            }
        }

        this.resetNewOffice()
    },

    methods: {
        getPhoneRegex () {
            return '^(\\' + this.getCurrentCountryPhonePrefix() + '[0-9]{8,10})$'
        },

        resetNewOffice () {
            this.newOffice = {
                "name": "",
                "streetName": "",
                "streetNumber": "",
                "zipCode": "",
                "locality": "",
                "location": null,
                "countryId": this.defaultCountryId,
                "phone": "",
                "isEmergencyEmailAlertEnabled": true
            }

            this.$emit('positionChanged', {
                name: 'office',
                location: null
            })
        },

        geocode (onSuccess, onError) {
            this.setLoading(true)

            axios.get(GEOCODE_BASE_URL, {
                params: {
                    address: this.getFullAddress(),
                    key: process.env.GEOCODING_API_KEY
                }
            })
            .then(({data}) => {
                if (data.results.length) {
                    this.newOffice.location = new firebase.firestore.GeoPoint(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng)

                    this.$emit('positionChanged', {
                        name: 'office',
                        location: this.newOffice.location
                    })

                    onSuccess()
                } else {
                    onError({ message: this.$t('DoctorProfile.geocoding_no_results_found') })
                }
            })
            .catch(onError)
        },

        getCurrentCountryName () {
            return this.$t('Countries.' + (this.countries[this.newOffice.countryId] ? this.countries[this.newOffice.countryId].code : 'default'))
        },

        getCurrentCountryPhonePrefix() {
            return this.countries[this.newOffice.countryId] ? this.countries[this.newOffice.countryId].phonePrefix : ''
        },

        getFullAddress () {
            return `${this.newOffice.streetNumber} ${this.newOffice.streetName},${this.newOffice.zipCode} ${this.newOffice.locality} ${this.getCurrentCountryName()}`
        },

        createOffice () {
            this.setLoading(true)

            this.$validator.validateAll().then((result) => {
                if (! result) {
                    this.setLoading(false)

                    this.alertError(this.$t('fields_are_missing'))

                    return false
                }

                this.newOffice.name = this.newOffice.name.trim()
                this.newOffice.name = this.newOffice.name.charAt(0).toUpperCase() + this.newOffice.name.slice(1)
                this.newOffice.streetName = this.newOffice.streetName.trim()
                this.newOffice.streetName = this.newOffice.streetName.charAt(0).toUpperCase() + this.newOffice.streetName.slice(1)
                this.newOffice.locality = this.newOffice.locality.trim()
                this.newOffice.locality = this.newOffice.locality.charAt(0).toUpperCase() + this.newOffice.locality.slice(1)

                this.geocode(() => {

                    if (! this.newOffice.location || (this.newOffice.location.lat == process.env.DEFAULT_LAT && this.newOffice.location.lng == process.env.DEFAULT_LNG)) {
                        this.setLoading(false)

                        return false
                    }

                    doctorOfficeRepository.create(this.doctor, this.newOffice, (officeId) => {
                        this.setCurrentOffice(officeId)

                        this.$router.push({ name: 'doctor.profile.office', params: {id: officeId} })

                        this.alertSuccess(this.$t('alert_create_successful'))

                        this.$validator.reset()
                        this.resetNewOffice()

                        this.setLoading(false)
                    })

                }, (error) => {
                    this.setLoading(false)

                    this.alertWarning(error.message)
                })
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Doctor/ProfileNewOffice.vue